export const formatLimitTextCharacters = (text: string, num: number) => {
  if (text.length <= num) {
    return text
  } else {
    return text.substring(0, num) + '...'
  }
}
